declare global {
    interface Window {
        google?: any;
    }
}

let loaderPromise: Promise<typeof window.google | null> | null = null;

export const getGoogleMapsApiKey = (): string =>
    (process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "").trim();

let warnedDemoMapId = false;

// Map ID for Advanced Markers. Falls back to Google's demo ID (default
// styling) so the map still works when the env var isn't configured.
export const getGoogleMapsMapId = (): string => {
    const configured = (process.env.REACT_APP_GOOGLE_MAPS_MAP_ID || "").trim();
    if (configured) return configured;
    if (!warnedDemoMapId) {
        warnedDemoMapId = true;
        console.warn(
            "[googleMapsLoader] REACT_APP_GOOGLE_MAPS_MAP_ID is not set — falling back to DEMO_MAP_ID.",
        );
    }
    return "DEMO_MAP_ID";
};

export const loadGoogleMaps = (): Promise<typeof window.google | null> => {
    if (loaderPromise) return loaderPromise;

    const apiKey = getGoogleMapsApiKey();
    if (!apiKey) {
        loaderPromise = Promise.resolve(null);
        return loaderPromise;
    }

    if (
        typeof window !== "undefined" &&
        window.google?.maps?.places &&
        window.google?.maps?.marker
    ) {
        loaderPromise = Promise.resolve(window.google);
        return loaderPromise;
    }

    loaderPromise = new Promise((resolve) => {
        const existing = document.querySelector<HTMLScriptElement>(
            'script[data-pa-google-maps="1"]',
        );
        const onReady = () => {
            if (window.google?.maps?.places && window.google?.maps?.marker)
                resolve(window.google);
            else resolve(null);
        };
        if (existing) {
            existing.addEventListener("load", onReady, { once: true });
            existing.addEventListener("error", () => resolve(null), { once: true });
            return;
        }
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(
            apiKey,
        )}&libraries=places,marker&v=weekly`;
        script.async = true;
        script.defer = true;
        script.dataset.paGoogleMaps = "1";
        script.addEventListener("load", onReady, { once: true });
        script.addEventListener("error", () => resolve(null), { once: true });
        document.head.appendChild(script);
    });

    return loaderPromise;
};
